import { TFunction } from 'i18next';

export const balances = (t: TFunction) => [
  {
    title: t('pages.cabinet.main_balance'),
    subtitle: t('pages.cabinet.main_balance_subtitle'),
    money: 300,
  },
  {
    title: t('pages.cabinet.package_balance'),
    subtitle: t('pages.cabinet.package_balance_subtitle'),
    money: 300,
  },
  {
    title: t('pages.cabinet.bonus_balance'),
    subtitle: t('pages.cabinet.bonus_balance_subtitle'),
    money: 300,
  },
];
